export default class FileForm {
  id: string = '';
  file: string = '';

  constructor(data?: Partial<FileForm>) {
    Object.assign(this, data);
  }
}
